
export class FontStyle {
bold: boolean | null;
color: string;
italic: boolean | null;
name: string;
strikeout: boolean | null;
}

